// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Button, Typography, Upload, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { UploadFile } from 'antd/lib/upload/interface';
import Modal from 'atoms/modal/modal';
import ModalBody from 'atoms/modal/modalBody';
import './fileUploader.scss';

const { Dragger } = Upload;
const { Text, Title } = Typography;

const FileUploader: React.FC<Props> = ({ onUpload, files, disabled }) => {
	const [fileList, setFileList] = useState<UploadFile[]>([]);

	const handleFileUpload = (info: { fileList: UploadFile[] }) => {
		let fileList = [...info.fileList];
		fileList = fileList.slice(-1);
		fileList = fileList.map((file) => {
			if (file.response) {
				file.url = file.response.url;
			}
			file.status = 'done';
			return file;
		});
		setFileList(fileList);
		onUpload(fileList);
	};
	const removeFile = (uid: string) => {
		const filteredFiles = fileList.filter((file) => file.uid !== uid);
		setFileList(filteredFiles);
		onUpload(filteredFiles);
	};

	useEffect(() => {
		setFileList(files);
	}, [files]);
	return (
		<>
			<div className="drag-drop-block ra-buttons">
				<Dragger
					name="file"
					disabled={disabled}
					multiple={false}
					onChange={handleFileUpload}
					accept=".csv"
					fileList={fileList}
					beforeUpload={() => false}
					style={{ width: '100%' }}
				>
					<i className="icon-export" />
					<Title level={5}>
						<span>Click to Upload</span> or Drag and Drop
					</Title>
					<div className="file-info">
						<Text>Supported format: .csv </Text>
						<Text>Max file size 10 MB</Text>
					</div>
				</Dragger>

				{/* Uploaded Files List */}
			</div>
			{fileList?.length > 0 && (
				<div className="upload-file-list">
					{fileList?.map((file) => (
						<div key={file.uid} className="upload-file-info">
							<div className="file-info">
								<Text>
									<i className="icon-pin-page" />
								</Text>
							</div>
							<div className="file-info">
								<Text>{file?.name}</Text>
							</div>
							{/* <div className="file-info" style={{ justifyContent: "center" }}>
                <Text>{(file?.size / 1024).toFixed(2)} KB</Text>
              </div>
              <div className="file-info status-btns">
                <Button type="link">
                  <i className="icon-tick-circle" />
                </Button>
                <Button type="link" onClick={() => removeFile(file?.uid)}>
                  <i className="icon-close-circle" />
                </Button>
              </div> */}
						</div>
					))}
				</div>
			)}
		</>
	);
};

export default FileUploader;
